import usePrivateAxios from "@/common/api/usePrivateAxios"
import { UserValidationSchema } from "@/common/schemas/create.schema"
import { UserData } from "@/common/types/users"
import { transformNewGeos } from "@/common/utils/geoTransformers"
import { getRailsUpdate } from "@/common/utils/getRailsUpdate"
import { mapToDeletion } from "@/common/utils/railsHelpers"
import { transformNewRoles } from "@/common/utils/roleTransformers"
import { removeSpecialCharacters } from "@/common/utils/unFormatters"
import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

interface UseUpdateUserProps {
  user: UserData | undefined
  file: Blob | undefined
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

const useUpdateUser = ({ user, file, onSuccess, onError }: UseUpdateUserProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateUser'],
    mutationFn: async (form: UserValidationSchema) => {
      const payload = {
        ...form,
        id: user?.id,
        cpf: form.cpf ? removeSpecialCharacters(form.cpf) : null,
        user_roles_attributes: getRailsUpdate(user?.user_roles || [], form?.roles || [], (userRole) => userRole.role.id, (role) => role.value || '', mapToDeletion, transformNewRoles),
        status: form?.status?.value || 'enabled',
        geo_geoables_attributes: getRailsUpdate(user?.geo_geoables || [], form?.geos || [], (geo) => geo.geo.id, (geo) => geo.value || '', mapToDeletion, transformNewGeos),
        phone_attributes: {
          number: form?.phone?.number ? removeSpecialCharacters(form?.phone?.number) : ''
        },
        profile_picture: file ? file : undefined,
        authentication_method: form.authentication_method?.value || undefined,
      }

      return privateAxios.put(`/users/${user?.id}`, { user: payload }, {
        headers: {
          'content-type': "multipart/form-data"
        }
      })
    },
    onSuccess,
    onError,
  })
}

export default useUpdateUser